<template>
  <page-view
    :backLink="backLink"
    backText="Back to Commerce"
    class="subpage"
    :title="transaction ? transaction.customer_reference || transaction.id : state === 'loading' ? 'Loading customer' : 'Could not find customer'"
  >
    <template v-slot:id>
      <template v-if="transaction">
        <id :id="transaction.id" />
      </template>
    </template>
    <template v-if="transaction">
      <div class="d-f fd-c fd-xl-r">
        <card-minimal title="Summary" class="summary f-1">
          <div class="p-a-4">
            <p class="card-content-title">{{ isEmail ? 'Email' : 'Phone number'}}</p>
            {{ transaction.customer_reference }}
            <hr class="m-y-2" />
            <template v-if="!isEmail">
              <p class="card-content-title">Play user</p>
              {{ transaction.play_user.email }}
              <hr class="m-y-2" />
            </template>
            <div class="d-f">
              <div class="f-1">
                <p class="card-content-title">Amount</p>
                <p>{{ transaction.formated_amount }}</p>
              </div>
              <div class="f-1">
                <p class="card-content-title">Fee</p>
                <p>{{ transaction.formated_fee }}</p>
              </div>
            </div>
            <hr class="m-y-2" />
            <p class="card-content-title">Purchase date</p>
            <p>{{ transaction.created_at | formatdate('MMMM DD, YYYY, HH:mm')}}</p>
            <hr class="m-y-2" />
            <template v-if="transactionData">
              <p class="card-content-title">Transaction ID</p>
              <p>{{ transactionData.id }}</p>
              <hr class="m-y-2" />
              <p class="card-content-title">Expiration</p>
              <template v-if="transactionData.expirations.expire_after !== '0s'">
                <p>{{ transactionData.expirations.expire_after | formatduration }}</p>
              </template>
              <template v-else-if="transactionData.expirations.expire_after_use !== '0s'">
                <p>{{ transactionData.expirations.expire_after_use | formatduration }}</p>
              </template>
              <template v-else>
                <p>{{ transactionData.expirations.expire_at }}</p>
              </template>
              <hr class="m-y-2" />
            </template>
            <div class="d-f">
              <div>
                <p class="card-content-title">Type</p>
                <Tag :text="$t(`commerce.${transaction.type}`)" :class="{'purple': true, 'capitalize': true, 'm-l-4': true}" />
              </div>
              <div class="m-l-4">
                <p class="card-content-title">Status</p>
                <template v-if="(transaction.status == 'completed' || transaction.status == 'pending_transfer')">
                  <Tag :text="$t(`commerce.status_${transaction.status}`)" :icon="'check'" :class="{'capitalize': true}" />
                </template>
                <template v-else>
                  <Tag :text="$t(`commerce.status_${transaction.status}`)" :class="{'capitalize': true, 'gray': ((transaction.status != 'failed') ? true:false ), 'red': (transaction.status == 'failed')}" />
                </template>
              </div>
            </div>
            <template v-if="transaction.failed_reason">
              <hr class="m-y-2" />
              <p class="card-content-title">Failed reason</p>
              <p>{{ transaction.failed_reason | capitalizeFirstLetter }}</p>
            </template>
            <template v-if="ticket(transaction.product_id)">
              <hr class="m-y-2" />
              <p class="card-content-title">Ticket</p>
              <a :href="`/ticket/${ticket(transaction.product_id).id}`" @click.prevent="$router.push(`/ticket/${ticket(transaction.product_id).id}`)" class="link blue">{{ ticket(transaction.product_id).name }}</a>
            </template>
            <div>
              <template v-if="ticket(transaction.product_id)">
                <Button :class="`f-w ${newState === 'success' ? 'green' : ''} m-t-4`" @click="sendNewTicket" :disabled="newState !== ''" :loading="newState === 'loading'">
                  Send new ticket
                </Button>
              </template>
              <Button :class="`f-w ${refundState === 'success' ? 'green' : ''} m-t-4`" @click="refund" :disabled="refundState !== ''" :loading="refundState === 'loading'" v-if="(transaction.status === 'completed' || transaction.status === 'pending_transfer') && transaction.type != 'voucher'">
                Refund
              </Button>
            </div>
          </div>
        </card-minimal>
        <div class="f-2 m-l-sm-0 m-l-xl-4 m-t-3 m-t-xl-0">
          <transactions-list :disableSearch="true" :forceEmail="transaction.customer_reference" />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-f f-1 ai-c jc-c" v-if="state === 'loading'">
        <div class="loading-spinner large"></div>
      </div>
      <div class="d-f f-1 ai-c jc-c" v-else-if="state === 'error'">
        <p>Could not load transaction</p>
      </div>
    </template>
  </page-view>
</template>

<script>

import Tag from '@/components/tag.vue';
import TransactionsList from '@/components/Commerce/TransactionsList.vue';

export default {
  components: {
    Tag,
    TransactionsList,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    /**
     * The list of tickets that exists
     * @returns {Array}
     */
    tickets() {
      return this.$store.getters['Products/allStreams'];
    },
    isEmail() {
      return this.transaction.customer_reference.includes('@');
    },
  },
  methods: {
    async getTransaction() {
      this.transaction = await this.$store.dispatch('Transactions/getTransaction', this.id);
    },
    async getTransactionTicket() {
      this.transactionData = await this.$store.dispatch('Transactions/getTransactionTicket', this.id);
    },
    /**
     * Return the name of the blueprint that matches the ID
     */
    ticket(id) {
      return this.tickets.find(t => t.id === id);
    },
    /**
     * Refund transacation
     * @returns {Void}
     */
    async refund() {
      this.refundState = 'loading';
      const refunded = await this.$store.dispatch('Transactions/refundTransaction', this.id);

      if (!refunded) {
        swal({ title: this.$t('errors.error_occured'), text: this.$t('errors.cant_refund'), icon: 'error' });
        this.refundState = '';
        return;
      }

      this.refundState = 'success';

      this.refundTimeout = setTimeout(() => {
        this.refundState = '';
      }, 2000);

      await this.getTransaction();
    },
    async sendNewTicket() {
      const {
        transaction: {
          item,
          play_user: {
            email,
          },
          product_id,
        },
      } = this;

      const payload = {
        product_id,
        access: {
          content: item,
        },
        email: {
          to: email,
          not_sending: true,
        },
        metadata: {
          title: '',
          url: '',
        },
      };

      this.newState = 'loading';

      try {
        await ovpFetch('/vouchers', {
          method: 'POST',
          body: JSON.stringify(payload),
        });
      } catch (e) {
        swal({ title: 'An error occured', text: 'For some reason we could not send this ticket right now', icon: 'error' });
        this.sendingNew = false;
        return;
      }

      this.newState = 'success';

      this.sentTimeout = setTimeout(() => {
        this.newState = '';
      }, 2000);

      // await this.getTransaction();
    },
  },
  watch: {
    async id() {
      this.state = 'loading';
      await this.getTransaction();
      await this.getTransactionTicket();
      this.state = '';
    },
  },
  data() {
    return {
      transaction: null,
      transactionData: null,
      transactions: [],
      current_page: 1,
      max_page: 1,
      per_page: 20,
      refundState: '',
      newState: '',
      state: 'loading',
      refundTimeout: null,
      sentTimeout: null,
      total_transactions: 0,
      backLink: '/commerce',
    };
  },
  async mounted() {
    const lastRoute = this.$store.getters['Theme/lastRoute'];
    if (lastRoute && lastRoute.path.includes('commerce')) {
      this.backLink = lastRoute.fullPath;
    }

    if (this.tickets.length === 0) {
      await this.$store.dispatch('Products/getAllStreams');
    }
    await this.getTransaction();
    await this.getTransactionTicket();
    this.state = '';
  },
  beforeDestroy() {
    clearTimeout(this.refundTimeout);
    clearTimeout(this.sentTimeout);
  },
};
</script>
